var React = require('react');
var css = require('./module.scss');
/**
 * 使用方法
 * <Button text="submit" style="primary" size="lg" disabled={true} type="link"/>
 *
 * style: primary, red, 默认default样式
 * size: sm, lg, 默认default
 */

var Button = React.createClass({

    render: function() {
        var cls = ['fp-btn', this.props.className];

        if (this.props.noRadius) {
            cls.push('fp-btn-no-radius');
        }
        if (this.props.style) {
            cls.push('fp-btn-' + this.props.style);
        }

        if (this.props.size) {
            cls.push('fp-btn-' + this.props.size);
        }

        if (this.props.icon) {
            cls.push('fp-btn-icon-' + this.props.icon);
        }

        if (this.props.type == 'link') {
            return (
                <a className={cls.join(' ')}
                    href={this.props.href || 'javascript:;'}
                    target={this.props.target}
                    onClick={this.props.onClick}>
                    {this.props.text}
                    {this.props.children}
                </a>
            );
        }

        return (
            <button
                className={cls.join(' ')}
                type={this.props.type || 'button'}
                disabled={this.props.disabled}
                onClick={this.props.onClick}>
                {this.props.text}
                {this.props.children}
            </button>
        );
    }

});

module.exports = Button;



// WEBPACK FOOTER //
// ./component/button/index.js